export default async function buywaySimulation(totalAmount) {
  const apiUrl = `https://lab9.apps.esign.eu/api/buy-way/simulations?creditAmount=${totalAmount}&test_mode=true`;

  async function fetchLegalNotice(legalNoticeUrl) {
    try {
      const response = await fetch('https://lab9.apps.esign.eu/api/buy-way/legal-notice', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          legal_notice_url: legalNoticeUrl,
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.text();

      // Set buy way legal notices
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const bodyContent = doc.body.innerHTML;

      const buyWayLegalNoticesElements = document.querySelectorAll('.js-legal-notices');
      buyWayLegalNoticesElements.forEach((element) => {
        element.innerHTML = bodyContent;
      });

      return data;
    } catch (error) {
      console.error('Error fetching legal notice:', error);
      throw new Error('Error');
    }
  }

  try {
    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    let lowestMonthlyPaymentObject = null;

    const locale = document.documentElement.lang;

    if (locale === 'fr') {
      fetchLegalNotice(data[0].legalNotices.fr);
    } else {
      fetchLegalNotice(data[0].legalNotices.nl);
    }

    if (data.length > 0) {
      // Sort the data by monthly payment
      const dataSorted = data.sort((a, b) => a.monthlyPayment - b.monthlyPayment);
      [lowestMonthlyPaymentObject] = dataSorted;

      if (lowestMonthlyPaymentObject) {
        const { creditCost, monthlyPayment, numberOfPayments, taeg } = lowestMonthlyPaymentObject;

        // Get all .js-buy-way-simulation elements
        const buyWaySimulationElements = document.querySelectorAll('.js-buy-way-simulation');
        buyWaySimulationElements.forEach((wrapper) => {
          if (!lowestMonthlyPaymentObject || !monthlyPayment || !numberOfPayments || !taeg) {
            // hide wrapper if no data
            wrapper.style.display = 'none';
            return;
          }

          // Show wrapper
          wrapper.style.display = 'flex';

          // Set month simulation
          const monthSimulationEl = wrapper.querySelector('.js-buy-way-simulation-month');
          if (monthSimulationEl) {
            const monthlyPaymentFormatted = `€ ${monthlyPayment.toString().replace('.', ',')}`;
            monthSimulationEl.innerHTML = `${numberOfPayments} x <strong>${monthlyPaymentFormatted}</strong>`;
          }

          // Set credit cost
          const creditCostEl = wrapper.querySelector('.js-buy-way-simulation-credit-cost');
          if (creditCostEl) {
            creditCostEl.textContent = `€ ${creditCost.toString().replace('.', ',')}`;
          }

          // Set JKP
          const jkpEl = wrapper.querySelector('.js-buy-way-simulation-jkp');
          if (jkpEl && taeg) {
            jkpEl.textContent = `${taeg.toString().replace('.', ',')}%`;
          }
        });
      }
    }
  } catch (error) {
    throw new Error('Error');
  }
}
